<template>
    <div>
        <div v-if="emptyAccessList()">Not linked yet.</div>
        <div v-else>
            <kotobee-resource-summary v-if="!emptyAccessOb(accessList.libid)" type="libs" label="Global library:" :access="accessList.libid" />
            <kotobee-resource-summary v-if="!emptyAccessOb(accessList.bid)" type="libBooks" label="Library ebook(s):" :access="accessList.bid" />
            <kotobee-resource-summary v-if="!emptyAccessOb(accessList.rid)" type="roles" label="Library role(s):" :access="accessList.rid" />
            <kotobee-resource-summary v-if="!emptyAccessOb(accessList.catid)" type="categories" label="Library category(-ies):" :access="accessList.catid" />
            <kotobee-resource-summary v-if="!emptyAccessOb(accessList.cid)" type="cloudBooks" label="Cloud ebook(s):" :access="accessList.cid" />
        </div>
    </div>
</template>

<script>
import KotobeeResourceSummary from "./KotobeeResourceSummary.vue"
export default {
    name: "ProductSummary",
    props: {
        accessList: Object
    },
    components: {
        KotobeeResourceSummary
    },
    methods: {
        /**
         * Checks whether an object is null or empty
         */
        emptyAccessOb(accessOb) {
            if (!accessOb) return true;
            if (accessOb == {} || accessOb == []) return true;
        },
        /**
         * Checks whether the accessList object is empty or invalid
         */
        emptyAccessList() {
            if (this.emptyAccessOb(this.accessList)) return true;

            const validAccess = ['libid', 'bid', 'rid', 'catid', 'cid'];
            for (let i = 0; i < validAccess.length; i++) {
                const a = validAccess[i];
                if (!this.emptyAccessOb(this.accessList[a])) return false;
            }

            return true;
        }
    },
    mounted() {
        console.log("product summary mounted with access: ", this.accessList);
    }
}
</script>

<style scoped>

</style>